import styled from 'styled-components';


const DashAppHolder = styled.div`
`;

export default DashAppHolder;
